import { render, staticRenderFns } from "./PageSwitcher.vue?vue&type=template&id=40e8c91f&scoped=true&"
import script from "./PageSwitcher.vue?vue&type=script&lang=js&"
export * from "./PageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./PageSwitcher.vue?vue&type=style&index=0&id=40e8c91f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8c91f",
  null
  
)

export default component.exports